/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAccountHandle.defs.js'
export { main as default } from './updateAccountHandle.defs.js'
